// Angular
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { enableProdMode } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';

// Ionic
import {
  IonicRouteStrategy,
  provideIonicAngular
} from '@ionic/angular/standalone';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Third library
import { Smartlook } from '@awesome-cordova-plugins/smartlook/ngx';

// Local library
import {
  CameraService,
  GeoLocationService,
  InactivityService,
  LoadService,
  SharedModule
} from '@amwager/util';
import { authenticationProviders } from '@amwager/authentication/data-access';
import {
  TransactionAPIService,
  JurisdictionAPIService,
  PermissionService,
  ToteProgramAPIService,
  ToteResultAPIService,
  ToteWageringAPIService,
  TotePoolInfoAPIService,
  VideoStreamingAPIService,
  ToteConfigurationAPIService,
  CommonFacade
} from '@amwager/data-access';
import { Environment as Env } from '@amwager/util-ts';
import { wagerProviders } from '@amwager/wager/data-access';
import { fundingProviders } from '@amwager/funding/data-access';
import { ticketProviders } from '@amwager/ticket/data-access';
import { AccountFacade, accountProviders } from '@amwager/account/data-access';

// Local files
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';



// Call the element loader before the bootstrapModule/bootstrapApplication call
defineCustomElements(window);

if (Env.Environment.production) {
  enableProdMode();
}

const isCypress = window['Cypress'] !== undefined;

bootstrapApplication(AppComponent, {
  providers: [
    Smartlook,
    ...SharedModule.commonProviders, // add common providers,
    ...authenticationProviders, // add authentication providers
    ...wagerProviders, // add wager providers
    ...fundingProviders, // add funding providers
    ...ticketProviders, // add ticket providers
    ...accountProviders, // add funding providers
    ToteProgramAPIService,
    ToteResultAPIService,
    ToteWageringAPIService,
    TotePoolInfoAPIService,
    ToteConfigurationAPIService,
    VideoStreamingAPIService,
    CameraService,
    PermissionService,
    TransactionAPIService,
    VideoStreamingAPIService,
    DecimalPipe,
    DatePipe,
    JurisdictionAPIService,
    LoadService,
    GeoLocationService,
    InactivityService,
    provideIonicAngular(), // ionic angular providers
    provideRouter(routes), // app routing
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    }, // routing strategy
  ],
}).then(appRef => {
  if (isCypress) {
    // Retrieve CommonFacade from the application's injector and attach it to window
    const commonFacade = appRef.injector.get(CommonFacade);
    const accountFacade = appRef.injector.get(AccountFacade);
    (window as any).commonFacade = commonFacade;
    (window as any).accountFacade = accountFacade;
  }
}).catch(err => console.error(err));
